import api from '@/api';

// Utilisateur de la session ({ id, username, email, status }) ou null si non connecté
export async function fetchSessionUser() {
  try {
    const response = await api.get('/session/me');
    return response.status === 200 && response.data && response.data.id ? response.data : null;
  } catch (error) {
    return null;
  }
}

// ADMIN et MODERATOR partagent les droits de modération (commentaires, signalements)
export function isStaff(user) {
  return !!user && (user.status === 'ADMIN' || user.status === 'MODERATOR');
}
